import Person, { names as personNames } from '@/common/interfaces/dto/Person';
import Phone, { names as phoneNames } from '@/common/interfaces/dto/Phone';
import { RecaptchaResponse } from '@/forms/FormElements/Mixins/RecaptchaMixin';
import { names as messageNames } from '@/forms/FormElements/Rows/MessageRow/MessageRow.validation';

export interface ChartersRequestModel extends RecaptchaResponse {
  Person: Person;
  Phone: Phone;
  Message: string;
  Organization: string;
  ExpectedTravelDate: string;
  NumberOfGuests: string;
  NumberOfGuestsAffinity: string;
  TypeId: number;
  AnalyticsPayload?: string;
  InterestDestinations: string;
  ExpectedTravelDateMonth: string;
  ExpectedTravelDateYear: string;
}

const formNames: { [key in keyof ChartersRequestModel]: keyof ChartersRequestModel } = {
  Person: 'Person',
  Phone: 'Phone',
  Organization: 'Organization',
  ExpectedTravelDate: 'ExpectedTravelDate',
  NumberOfGuests: 'NumberOfGuests',
  NumberOfGuestsAffinity: 'NumberOfGuestsAffinity',
  TypeId: 'TypeId',
  Message: messageNames.Message as keyof ChartersRequestModel,
  InterestDestinations: 'InterestDestinations',
  ExpectedTravelDateMonth: 'ExpectedTravelDateMonth',
  ExpectedTravelDateYear: 'ExpectedTravelDateYear',
};

export const names = {
  ...personNames,
  ...formNames,
  ...phoneNames,
};
